import { useState, useEffect } from 'react';
import axios from 'axios';
import Page from "../components/Page";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactJson from 'react-json-view';
import Header from '../components/Header';

const EventManagement = ({ authToken }) => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState("");
  const [responseData, setResponseData] = useState(null); // State to store response data
  const [onloadedData, setOnloadedData] = useState(null); // State to store loaded data


  const [isCollapsedEvents, setIsCollapsedEvents] = useState(true); // State to manage collapsible section
  const [isCollapsedLoadedData, setIsCollapsedLoadedData] = useState(false); // State to manage collapsible section

  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file to upload");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      const fileContent = event.target.result;
      const lines = fileContent.split('\n').map(line => line.trim()).filter(line => line);

      const events = [];
      for (let i = 0; i < lines.length; i += 2) {
        const entry = lines[i] + ' ' + (lines[i + 1] || '');
        const event = await parseEntry(entry);
        if (event) {
          events.push(event);
        } else {
          console.log(`Invalid entry: ${entry}`);
        }
      }

      setOnloadedData(events);
      
      toast.success("File processed successfully!");
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      toast.error("Error reading file");
    };

    reader.readAsText(file);
  };

  const parseEntry = async (entry) => {
    console.log(`Parsing entry: ${entry}`); // Debugging: Print the entry being parsed
    const match = entry.match(/(\d{4}|TBA) - (\d{2}\/\d{2}\/\d{2}) - (.+?),\s*(\w{2})(?:\s*-\s*(.+?))?\s+(https?:\/\/\S+)/);
    if (match) {
      const [_, time, date, location, countryCode, description = "", url] = match;
      const formattedDate = formatDate(date);
      const formattedTime = formatTime(time);
      if (validateDate(formattedDate) || time === "TBA") {
        let finalCountryCode = countryCode;
        if (!countryCode) {
          finalCountryCode = await getCountryCode(location);
        }
        if (!finalCountryCode) {
          console.error(`Invalid country code: ${countryCode}`);
          toast.error(`Invalid country code: ${countryCode}`);
          return null;
        }
        return { description, start_time: formattedTime, date: formattedDate, location, country: finalCountryCode, ticket_link: url };
      }
    }
    return null;
  };

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/').map(Number);
    return `20${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  };

  const formatTime = (timeStr) => {
    if (timeStr === "TBA") {
      return '00:00';
    }
    return `${timeStr.slice(0, 2)}:${timeStr.slice(2)}`;
  };



  const validateDate = (dateStr) => {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  };

  const getCountryCode = async (address) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyB5Bzl84JQbFJt-4o7qHEJSCQPytkn_hyY`;
    const response = await axios.get(url);
    if (response.status === 200) {
      const data = response.data;
      if (data.results.length > 0) {
        const components = data.results[0].address_components;
        for (const component of components) {
          if (component.types.includes('country')) {
            return component.short_name;
          }
        }
      }
    }
    return null;
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get("/api/v2/events", {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setResponseData(response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const handleEdit = (edit) => {
    setOnloadedData(edit.updated_src);
  };

  const createEvents = async () => {
    if (!onloadedData || onloadedData.length === 0) {
      toast.error("No data to upload");
      return;
    }

    for (const event of onloadedData) {
      try {
        console.log("Creating event:", event);
        console.log("Event data:", event); // Log the event data
        const response = await axios.post("/api/v2/events", event, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });
        console.log("Event created successfully:", response.data);
        toast.success(`Event created successfully: ${event.location}`);
      } catch (error) {
        console.error("Error creating event:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          toast.error(`Error creating event: ${event.location} - ${error.response.data.message}`);
        } else {
          toast.error(`Error creating event: ${event.location}`);
        }
      }
    }

    fetchEvents();
  };


  return (
    <Page >
      <Header header="Aggregate Events" />
      {responseData && (
        <div>
          <h2 className='pt-4'>Existing Events Response Data</h2>
          <p>Response gotten from /api/v2/events </p>
          <button onClick={() => setIsCollapsedEvents(!isCollapsedEvents)}>
            {isCollapsedEvents ? "View Json ➕" : "➖"}
          </button>
          <ReactJson src={responseData} theme="monokai" collapsed={isCollapsedEvents} />
        </div>
      )}
      <h1 className='pt-4'>Uploading new events</h1>
      <form onSubmit={handleFileUpload}>
        <input type="file" onChange={handleFileChange} />
        <button type="submit" disabled={isUploading} className="bg-white hover:bg-link text-black  py-2 px-2 rounded">
          {isUploading ? "Uploading..." : "Upload"}
        </button>
      </form>

      {onloadedData && (
        <div>
          <button onClick={() => setIsCollapsedLoadedData(!isCollapsedLoadedData)}>
            {isCollapsedLoadedData ? "View Loaded Data ➕" : "➖"}
          </button>
          <ReactJson 
            src={onloadedData} 
            theme="monokai" 
            collapsed={isCollapsedLoadedData} 
            onEdit={handleEdit}
            enableClipboard={true}
          />
          <button onClick={createEvents} className="bg-white hover:bg-link text-black font-bold py-2 px-4 rounded mt-4">
            Upload Events
          </button>
        </div>
      )}
      <ToastContainer />
    </Page>
  );
};

export default EventManagement;